import React, { useState, useEffect, ReactNode } from 'react';

interface ScalingWrapperProps {
  children: ReactNode;
  [x: string]: any; 
}

const ScalingWrapper: React.FC<ScalingWrapperProps> = ({ children, ...rest }) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const scaleWidth = window.innerWidth / 1080;
      const scaleHeight = window.innerHeight / 1920;
      setScale(Math.min(scaleWidth, scaleHeight));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="w-screen h-screen bg-black flex justify-center items-center overflow-hidden" {...rest}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: 'center center' }}>
        {children}
      </div>
    </div>
  );
};

export default ScalingWrapper;
